var exports = {
  "advantage": "x7f9a0e16--d21792--advantage",
  "blue": "x7f9a0e16--d21792--blue",
  "icon": "x7f9a0e16--d21792--icon",
  "content": "x7f9a0e16--d21792--content",
  "title": "x7f9a0e16--d21792--title",
  "description": "x7f9a0e16--d21792--description",
  "expertise": "x7f9a0e16--d21792--expertise",
  "personalization": "x7f9a0e16--d21792--personalization",
  "legal": "x7f9a0e16--d21792--legal",
  "support": "x7f9a0e16--d21792--support",
};

module.exports = exports;
